import { PROFILE_BIRTH_DATE_FORMAT } from '@/constants/profile';
import { startOfDay } from '@/helpers/date';

const padDatePart = (value) => String(value).padStart(2, '0');

export const formatBirthDateInput = (value) => {
  const digits = value.replace(/\D/g, '').slice(0, 8);

  return [digits.slice(0, 2), digits.slice(2, 4), digits.slice(4, 8)].filter(Boolean).join('.');
};

export const parseBirthDate = (value) => {
  const match = PROFILE_BIRTH_DATE_FORMAT.exec(value);
  if (!match) return null;

  const [, day, month, year] = match.map(Number);
  const date = new Date(year, month - 1, day);
  const isRealDate = date.getFullYear() === year && date.getMonth() === month - 1 && date.getDate() === day;

  return isRealDate ? date : null;
};

export const isPastBirthDate = (date, now = new Date()) => startOfDay(date).getTime() < startOfDay(now).getTime();

export const validateBirthDate = (value) => {
  const birthDate = parseBirthDate(value);
  if (!birthDate) return 'invalidDate';

  return isPastBirthDate(birthDate) ? null : 'birthDateInFuture';
};

export const toApiBirthDate = (date) => `${date.getFullYear()}-${padDatePart(date.getMonth() + 1)}-${padDatePart(date.getDate())}`;
